module.exports = "<div class=\"row\">\r\n  <div class=\"col-xs-10\">\r\n    <app-shopping-edit></app-shopping-edit>\r\n    <hr>\r\n    <ul class=\"list-group\">\r\n      <a\r\n        class=\"list-group-item\"\r\n        style=\"cursor: pointer\"\r\n        *ngFor=\"let ingredient of ingredients; let i = index\"\r\n        (click)=\"onEditItem(i)\"\r\n      >\r\n        {{ ingredient.name }} ({{ ingredient.amount }})\r\n      </a>\r\n    </ul>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shopping-list/shopping-list.component.html
// module id = ./src/app/shopping-list/shopping-list.component.html
// module chunks = main